import { cartConfigSession, configSession, dineConfigSession, dismissPendingOrders, recentAddressId, recentLocation, recentLocations, recentStores, sessionId, ssipSession, userSessionId, versioncontrol } from "@/config";

export const getStorageJSON = (key) => {
  try {
    const item = localStorage.getItem(key);
    if (item !== null && item !== undefined) {
      const data = JSON.parse(item);
      if (Object.keys(data)) {
        return data;
      } else return null;
    }
    return null;
  } catch (error) {
    console.error(
      `Error parsing JSON from localStorage for key ${key}:`,
      error
    );
    return null;
  }
};

export const getStorageString = (key) => {
  if (localStorage.getItem(key)) {
    return localStorage.getItem(key);
  } else {
    return null;
  }
};

export const getLocationSessions = () => getStorageString(recentLocations);

export const getStoresSessions = () => getStorageJSON(recentStores);

export const getSession = () => getStorageJSON(sessionId);

export const getUserSessionId = () => getStorageString(userSessionId);

export const getCartConfigSession = () => getStorageJSON(cartConfigSession);

export const getConfigSession = () => getStorageJSON(configSession);

export const getSSIPSession = () => getStorageString(ssipSession);

export const getDineConfigSession = () => getStorageJSON(dineConfigSession);

export const getLocationsSession = () => getStorageJSON(recentLocations);

export const getLocationsSessions = () => getStorageJSON(recentLocation);

export const getRecentAddressId = () => getStorageString(recentAddressId);

export const getVersionControl = () => getStorageJSON(versioncontrol);

export const getDismissedPendingOrders = () =>
  getStorageJSON(dismissPendingOrders);